import React from 'react';
import { useSelector } from 'react-redux';

import Loader from 'modules/kiosk/components/Loader';
import { RootState } from 'rootReducer';
import history from 'browserHistory';
import { routes } from '../../../../entities/Roles';
import classes from './Auth.module.scss';

export const Auth: React.FC = () => {
  const auth = useSelector((state: RootState) => state.authModuleReducer.authReducer);
  const name = auth.role?.name;

  // @ts-ignore
  if (name) history.push(routes[name]);
  return (
    <div className={classes.wrapper}>
      <Loader />
    </div>
  );
};
